import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { Dropdown } from "react-bootstrap";
import { deleteValidezNacional } from "services/validezNacional";

interface Props {
  elemento: ValidezNacionalI;
  onClickEdit: (elemento: ValidezNacionalI) => void;
  onClickShowDetail: (elemento: ValidezNacionalI) => void;
  refreshTable: () => void;
}

export const ValidezNacionalRowActions = ({
  elemento,
  onClickEdit,
  onClickShowDetail,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteValidezNacional(id);
      showSuccessToast("¡La validación nacional fue eliminado con éxito!");
      refreshTable();
    } catch (error) {
      showErrorToast("Error eliminando la validación nacional");
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickShowDetail(elemento)}>
          Ver detalle
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar Validez Nacional"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la Validez Nacional <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
